import { useState, useEffect } from "react";
import { useStyles } from "./modalContent";
import { normalizePrice } from "../../../utils/constants";

const ReusablePlanModal = ({
  isOpen,
  onClose,
  mode,
  providerData,
  onSubmit,
  onDelete,
}) => {
  const classes = useStyles();

  // Initialize formData based on providerData
  const [formData, setFormData] = useState({
    name: providerData?.name || "",
    singlePrice: "",
    familyPrice: "",
  });
  const [error, setError] = useState(null);

  // Update formData when providerData changes
  useEffect(() => {
    const normalizedPrice = normalizePrice(providerData?.price);
    setFormData({
      name: providerData?.name || "",
      singlePrice: normalizedPrice.single || "",
      familyPrice: normalizedPrice.family || "",
    });
  }, [providerData]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (!formData.name || !formData.singlePrice) {
      setError("Name and Single Price are required.");
      return false;
    }
    if (formData.familyPrice && Number(formData.familyPrice) <= 0) {
      setError("Family Price must be greater than 0 if provided.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    setError(null);
    if ((mode === "edit" || mode === "create") && !validateForm()) return;

    try {
      // Construct the price field based on formData
      const priceData =
        formData.familyPrice === "" || formData.familyPrice === "N/A"
          ? Number(formData.singlePrice) // Scalar price for plans like BASIC
          : {
              single: Number(formData.singlePrice),
              family: Number(formData.familyPrice),
            };

      const payload = {
        name: formData.name,
        price: priceData,
      };

      if (mode === "edit") {
        await onSubmit(providerData.id, payload);
      } else if (mode === "create") {
        await onSubmit(null, payload);
      } else if (mode === "delete") {
        await onDelete(providerData.id);
      }
      onClose();
    } catch (err) {
      setError("Operation failed. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1000",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "500px",
          boxShadow: "0 8px 10px rgba(0, 0, 0, 0.1)",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <h2>
          {mode === "edit"
            ? "Edit Health Plan"
            : mode === "create"
            ? "Create Health Plan"
            : "Delete Health Plan"}
        </h2>
        {error && <p style={{ color: "red" }}>{error}</p>}

        {(mode === "edit" || mode === "create") && (
          <form>
            <div>
              <label className={classes.enroleeIdText}>Plan Name:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={classes.enroleeInputId}
                required
              />
            </div>
            <div>
              <label className={classes.enroleeIdText}>Single Price:</label>
              <input
                type="number"
                name="singlePrice"
                value={formData.singlePrice}
                onChange={handleChange}
                className={classes.enroleeInputId}
                required
              />
            </div>
            <div>
              <label className={classes.enroleeIdText}>
                Family Price (optional):
              </label>
              <input
                type="number"
                name="familyPrice"
                value={formData.familyPrice}
                onChange={handleChange}
                className={classes.enroleeInputId}
                placeholder="Leave blank for plans like BASIC"
              />
            </div>
          </form>
        )}

        {mode === "delete" && (
          <p>
            Are you sure you want to delete the {providerData?.name} health
            plan?
          </p>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "#ccc",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            style={{
              padding: "8px 16px",
              background: mode === "delete" ? "#d32f2f" : "#1976d2",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            {mode === "edit" ? "Save" : mode === "create" ? "Create" : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReusablePlanModal;
